import React from "react";
import "./styles.styl";

const Collapsible = (props) => {
  const { children, isOpen, id, activeSearch } = props;
  const itemRef = props.categoryRef;

  return (
    <div className="collapsible" id={id} ref={itemRef}>
      {isOpen || activeSearch ? <>{children}</> : null}
    </div>
  );
};

export default Collapsible;
